import React from 'react';
import { Box, Container, CssBaseline } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import WhatsAppButton from '../WhatsAppButton/WhatsAppButton';

const Layout = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      <CssBaseline />
      <Navbar />
      
      {/* Add padding top to account for fixed navbar */}
      <Box component="main" sx={{ flexGrow: 1, pt: { xs: 8, md: 10 } }}>
        <AnimatePresence mode="wait">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <Container maxWidth="lg">
              {children}
            </Container>
          </motion.div>
        </AnimatePresence>
      </Box>
      
      <Footer />
      <WhatsAppButton />
    </Box>
  );
};

export default Layout;
